export default __webpack_public_path__ + "static/cli_mayorista10-677d1dbfba64c6ad6cf867fe2b4b6c16.png";